<template>
  <v-navigation-drawer
    :color="color"
    :value="isOpen"
    @input="toggleDrawer"
    v-bind="drawerProps"
  >
    <template v-slot:prepend>
      <slot name="prepend">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Menu</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </slot>
    </template>

    <!-- <v-list>
      <v-list-item
        v-for="item in filteredTopLinks"
        :key="item.title"
        :to="item.to"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list> -->
    <v-list>
      <v-list-item
        v-for="item in filteredTopLinks"
        :key="item.title"
        :to="item.to"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
          </template>
          <span>{{ $t(item.tooltip) }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-content
              v-bind="attrs"
              v-on="on"
            >
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <span>{{ $t(item.tooltip) }}</span>
        </v-tooltip>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-list>
        <v-list-item
          v-for="item in filteredBottomLinks"
          :disabled="item.disabled ? true : false"
          :key="item.title"
          :to="item.to"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { getTheme } from "@/plugins/vuetify"

export default {
  name: "DrawerGeneric",
  props: {
    colorKey: { type: String, default: "white" },
    isOpen: { type: Boolean, required: true },
    isSubDrawer: { type: Boolean, default: false },
    topLinks: { type: Array, default: () => [] },
    bottomLinks: { type: Array, default: () => [] }
  },
  data() {
    let drawerProps = this.isSubDrawer
      ? { app: true, clipped: true, permanent: true }
      : { app: true, temporary: true, dark: true }

    return {
      drawerProps: drawerProps
      // filteredBottomLinks: this.bottomLinks.filter(this.filterAllowedLink),
      // filteredTopLinks: this.topLinks.filter(this.filterAllowedLink)
    }
  },
  computed: {
    color() {
      return getTheme(this)[this.colorKey]
    },
    filteredTopLinks() {
      return this.topLinks.filter(this.filterAllowedLink)
    },
    filteredBottomLinks() {
      return this.bottomLinks.filter(this.filterAllowedLink)
    }
  },
  methods: {
    filterAllowedLink(link) {
      return link.isAllowed ? link.isAllowed(this) : true
    },
    toggleDrawer(newValue) {
      if (this.isOpen != newValue) {
        this.$emit("toggle", newValue)
      }
    }
  }
}
</script>
